var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 28.0001L42.7071 27.293L43.4142 28.0001L42.7071 28.7072L42 28.0001ZM14 29.0001C13.4477 29.0001 13 28.5524 13 28.0001C13 27.4478 13.4477 27.0001 14 27.0001V29.0001ZM33.3738 17.9596L42.7071 27.293L41.2929 28.7072L31.9596 19.3739L33.3738 17.9596ZM42.7071 28.7072L33.3738 38.0405L31.9596 36.6263L41.2929 27.293L42.7071 28.7072ZM42 29.0001H14V27.0001H42V29.0001Z",
    fill: "#FFFFF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactArrow);
export default __webpack_public_path__ + "static/media/contactArrow.f3364bfbb1e26a9be26e28873bae9ce2.svg";
export { ForwardRef as ReactComponent };